import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private readonly meta: Meta
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const route = this.getDeepestRoute(routerState.root);
    const routeData = route?.data ?? {};

    const pageTitle =
      routeData['title'] ?? 'Redmonk Wellness, House Of Hydration, Timeless Monk';
    const description =
      routeData['description'] ??
      'IV Therapy is transforming the health and wellness landscape by offering fast, effective solutions tailored to a wide range of wellness and cosmetic needs.';
    const canonicalUrl = routeData['canonicalUrl'] ?? 'https://www.redmonkwellness.com/';

    this.title.setTitle(pageTitle);

    this.meta.updateTag({ name: 'description', content: description }, "name='description'");
    this.meta.updateTag({ name: 'robots', content: 'index, follow' }, "name='robots'");
    this.meta.updateTag({ property: 'og:title', content: pageTitle }, "property='og:title'");
    this.meta.updateTag({ property: 'og:description', content: description }, "property='og:description'");
    this.meta.updateTag({ property: 'og:type', content: 'website' }, "property='og:type'");
    this.meta.updateTag({ property: 'og:url', content: canonicalUrl }, "property='og:url'");
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle }, "name='twitter:title'");
    this.meta.updateTag(
      { name: 'twitter:description', content: description },
      "name='twitter:description'"
    );

    if (typeof document !== 'undefined') {
      let canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }

      canonical.setAttribute('href', canonicalUrl);
    }
  }

  private getDeepestRoute(route: any): any {
    let current = route;
    while (current?.firstChild) {
      current = current.firstChild;
    }
    return current;
  }
}
